import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { ModalProps } from "../types";
import CustomButton from "./CustomButton";

export default function Modals({
  showDialog,
  onCloseDialog,
  title,
  width,
  height,
  isLoading,
  className,
  children,
  centerTitle,
  backButton,
}: ModalProps) {
  const navigate = useNavigate();
  const getStyles = () => {
    const styles: React.CSSProperties = {};

    if (width) {
      styles.width = `${width}px`;
    }

    if (height) {
      styles.height = `${height}px`;
    }

    return styles;
  };
  return (
    <div className="bg-background max-h-[90vh] overflow-y-auto fixed w-full">
      {backButton ? (
        <div
          style={getStyles()}
          className="bg-transparent block mx-auto mt-8 smallTablet:!w-[calc(100vw-2rem)] smallTablet:!h-auto smallTablet:mt-4"
          onClick={() => navigate(-1)}
        >
          {" "}
          <CustomButton
            className="text-label-muted hover:text-text-primary transition-colors !px-0 bg-transparent font-medium"
            renderLeftIcon={
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="text-label-muted text-base flex justify-center"
              />
            }
          >
            Back
          </CustomButton>
        </div>
      ) : null}
      <div
        style={getStyles()}
        className="bg-surface border border-edge h-full block mx-auto mt-6 mb-10 z-10 rounded-2xl shadow-card animate-fade-in smallTablet:!w-[calc(100vw-2rem)] smallTablet:!max-w-[calc(100vw-2rem)] smallTablet:!h-auto smallTablet:mt-3 smallTablet:mb-6"
      >
        {centerTitle ? (
          <div className="uppercase flex justify-center h-20 items-center smallTablet:h-14 smallTablet:px-4 smallTablet:text-center text-[16px] bg-gradient-heading bg-clip-text text-transparent font-heading-font">
            {title}
          </div>
        ) : null}
        <hr className="mx-6 border-edge-faint border-dashed smallTablet:mx-4" />
        <div>{children}</div>
      </div>
    </div>
  );
}
